import React from 'react';
import { Tag } from 'antd';
import dayjs from 'libs/dayjs';

export default function VisitaEnSitioBadge({ inicioAt, cierreAt }) {
  if (!inicioAt || cierreAt) return null;
  return (
    <Tag color="processing" style={{ marginInlineStart: 6 }}>
      En ejecución en sitio · desde {dayjs(inicioAt).format('HH:mm')}
    </Tag>
  );
}
